import Inicio from "pages/inicio";

export default function inicioPage() {
  return <Inicio />;
}
